define('models/credit_card',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        idAttribute: 'code',

        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'credit-cards/' + this.get('code') + '/' ) :
                ( App.Config.apiBase + 'credit-cards/' );
        },

        defaults: function () {
            return {
                card_holder_name: '',
                card_number: '',
                card_expiry: '',
                card_cvc: '',
                payment_service: 0,
            };
        }
    });
});
